export const SET_VIEW = 'SET_VIEW';
export function setView(value) {
  return {
    type: SET_VIEW,
    payload: {
      value
    }
  };
}
